import { editTask, statusOptions, taskStatusEnum } from '@/services/task/task'
import { Select } from 'antd'
import classnames from 'classnames'
import { memo, useEffect, useState } from 'react'
import styles from './index.module.less'

export default memo(function TaskStatus(props: any) {
  const { task, editable = true, onSuccess } = props
  const [editing, setEditing] = useState(props.editing || false)
  const [value, setValue] = useState<any>()

  useEffect(() => {
    setValue(task.status)
  }, [task])

  const handleChange = async (newValue) => {
    if (newValue) {
      const data = await editTask(task.id, { status: newValue })
      onSuccess?.(data)
      setEditing(false)
      setValue(newValue)
    } else {
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <Select
        className='w100'
        autoFocus
        value={value}
        onChange={(newValue) => {
          handleChange(newValue)
        }}
        onBlur={() => {
          setEditing(false)
        }}
        open={true}
      >
        {statusOptions.map((item) => (
          <Select.Option value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    )
  }

  return (
    <div
      className={styles.fieldItem}
      onClick={() => {
        if (editable) {
          setEditing(true)
        }
      }}
    >
      {value && <span className={classnames(styles.taskStatus, styles[value])}>{taskStatusEnum[value]}</span>}
    </div>
  )
})
